import * as remoteAction from "../remoteAction";

interface GetCoupon {
  eventType: string;
  campaignId: string;
  email?: string;
}

export type GetCouponActionSuccess = remoteAction.MerchantRemoteResponse<
  "GET_COUPON_SUCCESS",
  any
>;
export type GetCouponActionFailure = remoteAction.MerchantRemoteResponse<
  "GET_COUPON_FAILURE",
  any
>;
export type GetCouponActionRequest = remoteAction.MerchantRemoteResponse<
  "GET_COUPON_REQUEST",
  any
>;

export interface GetCouponAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "GET_COUPON_REQUEST";
    success: "GET_COUPON_SUCCESS";
    failure: "GET_COUPON_FAILURE";
  };
}

export function getCoupon(data: GetCoupon): GetCouponAction {
  return {
    data,
    method: "GET",
    params: data,
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "GET_COUPON_FAILURE",
      request: "GET_COUPON_REQUEST",
      success: "GET_COUPON_SUCCESS",
    },
    https: true,
    url: "/rewards/coupon",
  };
}
